
window.onload = function() {
  
  //    $('.product-medias__main .cstm_product_slider').slick({
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows:true,
  //   prevArrow: '<div class="swiper-button-prev swiper_prev_btn"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></div> ',
  //   nextArrow:'<div class="swiper-button-next swiper_next_btn"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></div>'
      
  // });
  
};


$(document).ready(function(){


  $('.slider_collection').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 7,
    slidesToScroll: 3,
    dots:true,
    arrows:false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          adaptiveHeight: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.feature_slide').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots:false,
    prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="24" height="24"><path d="M13.775,18.707,8.482,13.414a2,2,0,0,1,0-2.828l5.293-5.293,1.414,1.414L9.9,12l5.293,5.293Z"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="24" height="24"><path d="M10.811,18.707,9.4,17.293,14.689,12,9.4,6.707l1.415-1.414L16.1,10.586a2,2,0,0,1,0,2.828Z"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(document).on('click',".zoom-icon", function(){
    $(this).closest('.swiper-slide').find('.gallery img').click();
  });
  $(document).on('click',".product-medias__media.gallery img", function(){
     $('.product-modal').show();
     var imageId=$(this).parent().attr('data-media-id');
     var dataproducthandle=$(this).attr("data-product");
     var dataId = $(this).parent().attr('data-media-id');
     var dataThumbIndex = $('a.product-medias__thumbnail[data-media-id="'+dataId+'"]').attr('data-index');
    // console.log(dataId);
    
      $.getJSON(window.Shopify.routes.root + 'products/'+dataproducthandle+'.js', function(product) { 
     
      var mediaLenght = product['media'].length;
      var productThumbimages=product['media']; 
      var slider='<div class="swiper-container productImages"><div class="swiper-wrappers"></div><div>';
      var sliderButton='<div class="swiper-button-prev"></div><div class="swiper-button-next"></div><div class="swiper-pagination"></div>'; 
       
      if($('.productImages').length > 0){}else{
       $('.product-modal-inner').append(slider);
       $('.swiper-container.productImages').append(sliderButton);
         
       $.each(productThumbimages, function(key,value) {
            var productItemId=value['id'];
            var productItemImage=value['src']; 
            var productMainImg='<div class="swiper-slide" id="'+productItemId+'"><img class="Main_image"  src="'+productItemImage+'"/></div>';
            $('.productImages .swiper-wrappers').append(productMainImg);
       
       }); 
            $('.productImages .swiper-wrappers').slick({
            slidesToShow: 1,
            arrows:true,
            infinite: true,
            adaptiveHeight: true,
            centerMode:false,
            dots: true,
            prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></button>',
            nextArrow:'<button type="button" class="slick-next pull-right"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></button>'
          });
        } 
        $('.productImages .swiper-wrappers').slick('slickGoTo', dataThumbIndex);
     }); 
      
  });

  
  $(document).on('click',".product-modal-close", function(){
    $('.product-modal').hide();
  }); 

  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  
  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  
  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  
  });

if ($(".new__testimonal").length) {
    var swiper = new Swiper(".new__testimonal", {
        slidesPerView: 1,
        infinite: true,
        loop: true,
        speed: 5000,
        delay: 11000, 
        autoplay: {
            delay: 11000,
        }, 
        centeredSlides: true,
        grabCursor: true, 
        keyboard: {
            enabled: true,
        }, 
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: '.swiper-button-next.new__testimonal_next',
            prevEl: '.swiper-button-prev.new__testimonal_prev',
        }
    });
}


 // $('.newTesti').slick({
 //    infinite: true,
 //    speed: 300,
 //    slidesToShow: 1,
 //    slidesToScroll: 1,
 //    dots:false,
 //    adaptiveHeight: true,
 //    prevArrow:'<button type="button" class="slick-prev pull-left" ><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" style="border-radius:50%; background-color:white;"  data-name="Layer 1" viewBox="0 0 24 24" width="40" height="40"><path d="M13.775,18.707,8.482,13.414a2,2,0,0,1,0-2.828l5.293-5.293,1.414,1.414L9.9,12l5.293,5.293Z"/></svg></button>',
 //    nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" style="border-radius:50%; background-color:white;" data-name="Layer 1" viewBox="0 0 24 24" width="40" height="40"><path d="M10.811,18.707,9.4,17.293,14.689,12,9.4,6.707l1.415-1.414L16.1,10.586a2,2,0,0,1,0,2.828Z"/></svg></button>',
 //   }); 

  // var swiper = new Swiper(".newTesti", {
  //       loop: true,
        
  //       slidesPerView: 1,
  //       paginationClickable: true,
  //       spaceBetween: 20,
  //     // slidesPerView: 1,
  //     // infinite: true,
  //     // loop: true,
  //     // speed:5000,
  //     // delay:11000, 
  //     // autoplay:true, 
  //     // centeredSlides:true,
  //     // grabCursor: true, 
  //     // keyboardControl: true, 
  //     // observer: true,
  //     // observeParents: true,
  //     navigation: {
  //       nextEl: '.swiper-button-next.new__testimonal_next',
  //       prevEl: '.swiper-button-prev.new__testimonal_prev',
  //     }
       
  //   });

  
/*--------- Faq Accordion Start ----------------*/
  function initializeTabs() {
  var $titleTab = $('.title_tab');

  // 2 second delay ke baad pehla tab active hoga
  setTimeout(function() {
    $('.title_tab:first').addClass('active');
  }, 2000);

  // Tab click functionality
  $titleTab.on('click', function(e) {
    e.preventDefault();

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).next().stop().slideUp(500);
      $(this).next().find('p').removeClass('show');
    } else {
      $(this).addClass('active');
      $(this).next().stop().slideDown(500);
      $(this).parent().siblings().children('.title_tab').removeClass('active');
      $(this).parent().siblings().children('.inner_content').slideUp(500);
      $(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
      $(this).next().find('p').addClass('show');
    }
  });
}

// Function ko call karo jab DOM ready ho
$(document).ready(function() {
  initializeTabs();
});


  // setTimeout(function() {
  //   document.querySelector('.accordion__content#ProductAccordion-collapsible_tab_PCfhrm-template--product').style.display = 'block';
  // }, 2000);
//   $('.title_tab:first').addClass('active');
// var $titleTab = $('.title_tab');
	
// 	$titleTab.on('click', function(e) {
// 	e.preventDefault();
// 		if ( $(this).hasClass('active') ) {
// 			$(this).removeClass('active');
// 			$(this).next().stop().slideUp(500);
// 			$(this).next().find('p').removeClass('show');
// 		} else {
// 			$(this).addClass('active');
// 			$(this).next().stop().slideDown(500);
// 			$(this).parent().siblings().children('.title_tab').removeClass('active');
// 			$(this).parent().siblings().children('.inner_content').slideUp(500);
// 			$(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
// 			$(this).next().find('p').addClass('show');
// 		}
// 	});

/*--------- Faq Accordion End ----------------*/
  if($('.product-personalizer').length){
    
    }else{
        $('#AddToCart').removeClass('btn-error');
    }



});







// window.onload = function() {
  
//   //    $('.product-medias__main .cstm_product_slider').slick({
//   //   infinite: true,
//   //   speed: 300,
//   //   slidesToShow: 1,
//   //   slidesToScroll: 1,
//   //   arrows:true,
//   //   prevArrow: '<div class="swiper-button-prev swiper_prev_btn"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></div> ',
//   //   nextArrow:'<div class="swiper-button-next swiper_next_btn"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></div>'
      
//   // });
  
// };


// $(document).ready(function(){  

//   $('.slider_collection').slick({
//     infinite: true,
//     speed: 300,
//     slidesToShow: 7,
//     slidesToScroll: 3,
//     dots:true,
//     arrows:false,
//     responsive: [
//       {
//         breakpoint: 1025,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 2,
//           adaptiveHeight: true
//         }
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });

//   $('.feature_slide').slick({
//     infinite: true,
//     speed: 300,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     dots:false,
//     prevArrow:'<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="24" height="24"><path d="M13.775,18.707,8.482,13.414a2,2,0,0,1,0-2.828l5.293-5.293,1.414,1.414L9.9,12l5.293,5.293Z"/></svg></button>',
//     nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="24" height="24"><path d="M10.811,18.707,9.4,17.293,14.689,12,9.4,6.707l1.415-1.414L16.1,10.586a2,2,0,0,1,0,2.828Z"/></svg></button>',
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           infinite: true
//         }
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });

//   $(document).on('click',".zoom-icon", function(){
//     $(this).closest('.swiper-slide').find('.gallery img').click();
//   });
//   $(document).on('click',".product-medias__media.gallery img", function(){
//      $('.product-modal').show();
//      var imageId=$(this).parent().attr('data-media-id');
//      var dataproducthandle=$(this).attr("data-product");
//      var dataId = $(this).parent().attr('data-media-id');
//      var dataThumbIndex = $('a.product-medias__thumbnail[data-media-id="'+dataId+'"]').attr('data-index');
//     // console.log(dataId);
    
//       $.getJSON(window.Shopify.routes.root + 'products/'+dataproducthandle+'.js', function(product) { 
     
//       var mediaLenght = product['media'].length;
//       var productThumbimages=product['media']; 
//       var slider='<div class="swiper-container productImages"><div class="swiper-wrappers"></div><div>';
//       var sliderButton='<div class="swiper-button-prev"></div><div class="swiper-button-next"></div><div class="swiper-pagination"></div>'; 
       
//       if($('.productImages').length > 0){}else{
//        $('.product-modal-inner').append(slider);
//        // $('.swiper-container.productImages').append(sliderButton);
         
//        $.each(productThumbimages, function(key,value) {
//             var productItemId=value['id'];
//             var productItemImage=value['src']; 
//             var productMainImg='<div class="swiper-slide" id="'+productItemId+'"><img class="Main_image"  src="'+productItemImage+'"/></div>';
//             $('.productImages .swiper-wrappers').append(productMainImg);
       
//        }); 
//             $('.productImages .swiper-wrappers').slick({
//             slidesToShow: 1,
//             arrows:true,
//             infinite: true,
//             adaptiveHeight: true,
//             centerMode:false,
//             dots: true,
//             prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></button>',
//             nextArrow:'<button type="button" class="slick-next pull-right"><svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="Zoom-In_OnHover" transform="translate(-1238 -470)"><g id="Group-4" transform="translate(158 470)"><g id="Group-3" transform="matrix(-1 0 0 1 1130 0)"><g id="Group-9" fill="#FFF"><circle id="Oval-2" cx="25" cy="25" r="25"></circle></g><g transform="rotate(90 4 24)" stroke="#1F2A30" stroke-linecap="square" stroke-width="2"><path d="M0.5,0.5 L5.02268051,5.02268051" id="Line"></path><path d="M4.5,0.5 L9.02268051,5.02268051" id="Line-Copy" transform="matrix(-1 0 0 1 14 0)"></path></g></g></g></g></g></svg></button>'
//           });
//         } 
//         $('.productImages .swiper-wrappers').slick('slickGoTo', dataThumbIndex);
//      }); 
      
//   });

  
//   $(document).on('click',".product-modal-close", function(){
//     $('.product-modal').hide();
//   }); 

//   document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
//   summary.setAttribute('role', 'button');
//   summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  
//   if (summary.nextElementSibling.getAttribute('id')) {
//     summary.setAttribute('aria-controls', summary.nextElementSibling.id);
//   }
  
//   summary.addEventListener('click', (event) => {
//     event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
//   });
  
//   });


   

// if ($(".new__testimonal").length) {
//     var swiper = new Swiper(".new__testimonal", {
//         slidesPerView: 1,
//         infinite: true,
//         loop: true,
//         speed: 5000,
//         delay: 11000, 
//         autoplay: {
//             delay: 11000,
//         }, 
//         centeredSlides: true,
//         grabCursor: true, 
//         keyboard: {
//             enabled: true,
//         }, 
//         observer: true,
//         observeParents: true,
//         navigation: {
//             nextEl: '.swiper-button-next.new__testimonal_next',
//             prevEl: '.swiper-button-prev.new__testimonal_prev',
//         }
//     });
// }


//  $('.newTesti').slick({
//     infinite: true,
//     speed: 300,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     dots:false,
//     adaptiveHeight: true,
//     prevArrow:'<button type="button" class="slick-prev pull-left" ><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" style="border-radius:50%; background-color:white;"  data-name="Layer 1" viewBox="0 0 24 24" width="40" height="40"><path d="M13.775,18.707,8.482,13.414a2,2,0,0,1,0-2.828l5.293-5.293,1.414,1.414L9.9,12l5.293,5.293Z"/></svg></button>',
//     nextArrow:'<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" style="border-radius:50%; background-color:white;" data-name="Layer 1" viewBox="0 0 24 24" width="40" height="40"><path d="M10.811,18.707,9.4,17.293,14.689,12,9.4,6.707l1.415-1.414L16.1,10.586a2,2,0,0,1,0,2.828Z"/></svg></button>',
//    }); 

//   // var swiper = new Swiper(".newTesti", {
//   //       loop: true,
        
//   //       slidesPerView: 1,
//   //       paginationClickable: true,
//   //       spaceBetween: 20,
//   //     // slidesPerView: 1,
//   //     // infinite: true,
//   //     // loop: true,
//   //     // speed:5000,
//   //     // delay:11000, 
//   //     // autoplay:true, 
//   //     // centeredSlides:true,
//   //     // grabCursor: true, 
//   //     // keyboardControl: true, 
//   //     // observer: true,
//   //     // observeParents: true,
//   //     navigation: {
//   //       nextEl: '.swiper-button-next.new__testimonal_next',
//   //       prevEl: '.swiper-button-prev.new__testimonal_prev',
//   //     }
       
//   //   });

  
// /*--------- Faq Accordion Start ----------------*/
//   $('.title_tab:first').addClass('active');
// var $titleTab = $('.title_tab');
	
// 	$titleTab.on('click', function(e) {
// 	e.preventDefault();
// 		if ( $(this).hasClass('active') ) {
// 			$(this).removeClass('active');
// 			$(this).next().stop().slideUp(500);
// 			$(this).next().find('p').removeClass('show');
// 		} else {
// 			$(this).addClass('active');
// 			$(this).next().stop().slideDown(500);
// 			$(this).parent().siblings().children('.title_tab').removeClass('active');
// 			$(this).parent().siblings().children('.inner_content').slideUp(500);
// 			$(this).parent().siblings().children('.inner_content').find('p').removeClass('show');
// 			$(this).next().find('p').addClass('show');
// 		}
// 	});

// /*--------- Faq Accordion End ----------------*/
//   if($('.product-personalizer').length){
    
//     }else{
//         $('#AddToCart').removeClass('btn-error');
//     }



// });
document.addEventListener('DOMContentLoaded', function() {
  // Give Vue time to mount
  setTimeout(function() {
    var vue = document.querySelector('.product-single-wrapper')?.__vue__;
    if (!vue) return;
    document.querySelectorAll('.product-medias__media[data-media-id]').forEach(function(el) {
      var mediaId = parseInt(el.dataset.mediaId, 10);
      var wrapper = vue.mediaWrapperById?.get(mediaId);
      if (wrapper && !wrapper.el) {
        wrapper.el = el;
        // Attach click listener the same way onMediaLoaded does
        el.addEventListener('click', vue.onMediaActivate.bind(vue));
      }
    });
  }, 2000);
});
